<template>
<div class="shopMobVlive">
    <div class="titleBox">
        <div class="title"><span v-show="setting.isdisplaytitle === 1">{{setting.titlename}}</span></div>
        <div class="checkMore" v-if="setting.isdisplayall">查看更多</div>
    </div>
    <div class="vliveBox">
        <div class="vliveItem" v-for="(item, index) in setting.datalist" :key="index">
            <div class="imgBox">
                <img v-lazy="item.furl" alt="">
                <div class="status">
                    <div class="vliveIng">直播中</div>
                    <!-- <div class="beforeVlive">未开始</div>
                    <div class="vliveEd">已结束</div> -->
                </div>
                <div class="viewCount">
                    <img src="../../../../../common/images/shop/view-white.png" alt="">
                    <span>{{item.viewcount}}</span>
                </div>
            </div>
            <div class="vliveTitle">
                <span class="titleText">{{item.objectname}}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getVliveList} from 'api/api'
import $ from 'jquery'
export default {
    name: 'alive',
    props: ['setting'],
    data() {
        return {
            list: []
        }
    },
    mounted() {
        this._getVliveList()
    },
    updated() {
    },
    methods: {
        _getVliveList() {
            this.setLoading(true)
            getVliveList({
                data: {
                    ispublic: '',
                    subject: '',
                    page: 1,
                    pageSize: 2
                },
                success: data => {
                    let tmp = []
                    data.data.content.forEach(obj => {
                        tmp.push({
                            objectid: obj.innerid,
                            objectname: obj.subject,
                            kmctype: 3,
                            viewcount: 0,
                            uprice: 0,
                            saleprice: 0,
                            furl: obj.logourl,
                            desc: '',
                            streamstatus: obj.streamstatus
                        })
                    })
                    let tmpList = $.extend(true, [], this.shopMob)
                    tmpList.forEach((obj,index) => {
                        if (obj.comtype === 'alive') {
                            obj.datalist = tmp
                        }
                    })
                    this.setShopMob(tmpList)
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setShopMob',
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
@import "~common/scss/mixin";
.shopMobVlive {
    width: 15rem;
    // border: 1px solid #ccc;
    box-sizing: border-box;
    .titleBox{
        @include flexBox(space-between);
        padding: 0.64rem;
        height: 0.84rem;
        .title{
            font-size: 0.68rem;
            width: 11rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            span{
                font-weight: 600;
            }
        }
        .checkMore{
            font-size: 0.46rem;
            color: #909399;
        }
    }
    .vliveBox{
        width: 15rem;
        .vliveItem{
            margin-bottom: 0.96rem;
            .imgBox{
                position: relative;
                img{
                    width: 99%;
                    height: 8.44rem;
                }
                .status{
                    position: absolute;
                    top: 0;
                    div{
                        width: 1.92rem;
                        height: 0.76rem;
                        color: #fff;
                        text-align: center;
                        line-height: 0.76rem;
                        font-size: 0.48rem;
                    }
                    .vliveIng{
                        background: #409EFF;
                    }
                    .beforeVlive{
                        background: #E6A23C;
                    }
                    .vliveEd{
                        background: #909399;
                    }
                }
                .viewCount{
                    position: absolute;
                    bottom: 0.32rem;
                    left: 0.64rem;
                    color: #fff;
                    font-size: 0.46rem;
                    @include flexBox('');
                    img{
                        width: 0.48rem;
                        height: 0.48rem;
                        margin-right: 0.1rem;
                    }
                }
            }
            .vliveTitle{
                width: 13.72rem;
                height: 1.68rem;
                line-height: 0.84rem;
                margin: auto;
                overflow: hidden;
                .titleText {
                    float: right;
                    /* "margin-left"要等于".wrap::before"的宽度 */
                    margin-left: -10px;
                    width: 13.72rem;
                    word-break: break-all;
                    font-size: 0.56rem;
                    font-weight: 600;
                }
                &::before {
                    float: left;
                    content: '';
                    width: 10px;
                    height: 100%;
                }
                &::after {
                    float: right;
                    content: "...";
                    /* 行高与".wrap"设置的一致即可 */
                    height: 1.68rem;
                    line-height: 0.84rem;
                    /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                    width: 37px;
                    margin-left: -37px;
                    /* 移动省略号位置 */
                    position: relative;
                    left: 102%;
                    bottom: 0.8rem;
                    font-weight: 600;
                    /* "padding"左右总和的值要小于等于".wrap::before"的宽度，但不能为0 */
                    padding-right: 1px;
                    /*省略号左方的渐变色*/
                    background: #fff;
                    // background: linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -moz-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -o-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -ms-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), to(white), color-stop(20%, white));
                }
            }
        }
    }
}
</style>
